
import Vue from 'vue'
import Component from 'vue-class-component'

// Used for notifications.
import ErrorHandler from '@/services/ErrorHandlerService'
import { INotificationService } from '@/services/NotificationService'
import EventsService from '../../services/EventsService'
import BlueButton from '../Atomic/BlueButton.vue'
import GreenButton from '../Atomic/GreenButton.vue'
import RedButton from '../Atomic/RedButton.vue'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'
import ToolTipButton from '@/components/Atomic/ToolTipButton.vue'

@Component({
  components: {
    ToolTipButton,
    ProgressLinear,
    BlueButton,
    GreenButton,
    RedButton,
    CardTitle,
  },
})
export default class DeleteEvents extends Vue {
  private dialog: boolean = false
  private errorHandler = new ErrorHandler()
  private $notificationService!: INotificationService
  private isPending: boolean = false

  constructor() {
    super()
  }

  private async deleteEvents() {
    try {
      this.isPending = true
      const response = await EventsService.deleteEvents()
      this.$notificationService.success(
        this.$t('EVENT.DeleteSuccess').toString(),
      )
    } catch (error: any) {
      this.errorHandler.handle(this, error.response.data.code, true)
    } finally {
      this.$emit('update:events', [])
      this.$emit('update:filteredEvents', [])
      this.dialog = false
      this.isPending = false
    }
  }
}
